import React from "react";
import { Trash } from "lucide-react";

const ProductMockup = ({ images, onRemoveImage }) => {
  return (
    <div className="w-full max-w-2xl mx-auto bg-white rounded-lg shadow-lg p-6">
      <div className="space-y-6">
        <h3 className="text-lg font-medium text-gray-900">Product Preview</h3>
        <div className="bg-gray-50 p-6 rounded-lg">
          <div className="grid grid-cols-2 md:grid-cols-3 gap-8 place-items-center">
            {images.map((image, index) => {
              const imageUrl = image instanceof File ? URL.createObjectURL(image) : image;
              return (
                <div key={index} className="relative group">
                  <img
                    src={imageUrl}
                    alt={`Laptop Skin ${index + 1}`}
                    className="w-full h-full object-cover rounded-lg shadow-xl"
                  />
                  <button
                    onClick={() => onRemoveImage(index)}
                    className="absolute -top-2 -right-2 p-1.5 bg-red-500 text-white rounded-full opacity-0 group-hover:opacity-100 transition-opacity shadow-lg hover:bg-red-600"
                  >
                    <Trash className="w-4 h-4" />
                  </button>
                </div>
              );
            })}
          </div>
          {images.length === 0 && (
            <div className="text-center text-gray-400 py-12">
              Upload images to see how your designs will look on the product
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProductMockup;
